import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/Index.vue'
import LoginView from '../views/LoginView.vue'
import OrderView from '../views/OrderView.vue'
import QuotationView from '../views/QuotationView.vue'
import UserView from '../views/UserView.vue'
import AdminView from '../views/AdminView.vue'
import RegisterView from '../views/RegisterView.vue'
import ResetPwView from '../views/ResetPwView.vue'
import WechatLoginView from '../views/WechatLoginView.vue'

import axios from 'axios';
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'indexView',
		component: IndexView,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/login',
		name: 'loginView',
		component: LoginView
	},
	{
		path: '/order',
		name: 'OrderView',
		component: OrderView,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/quotation',
		name: 'QuotationView',
		component: QuotationView,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/user',
		name: 'UserView',
		component: UserView,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/admin',
		name: 'adminView',
		component: AdminView,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/register',
		name: 'RegisterView',
		component: RegisterView,
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/resetPw',
		name: 'ResetPwView',
		component: ResetPwView,
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/wechatLogin',
		name: 'WechatLoginView',
		component: WechatLoginView,
		meta: {
			requiresAuth: false
		}
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	const isAuthenticated = localStorage.getItem('authToken');
	if (to.matched.some(record => record.meta.requiresAuth)) {
		//仅"移动端微信"支持网页授权，可自动跳转微信授权登录；
		//微信电脑版(Windows/Mac)不支持网页授权，若也自动跳转会导致反复跳转进不去，因此需排除
		const ua = navigator.userAgent.toLowerCase();
		const isWechatDesktop = ua.includes('windowswechat') || ua.includes('macwechat')
			|| ua.includes('windows nt') || ua.includes('macintosh');
		const isWechatMobile = ua.includes('micromessenger') && !isWechatDesktop;
		if (isWechatMobile && !isAuthenticated) {
			window.location.href = '/kt-supplier/wechat/loginUrl';
			return;
		}
		if (!isAuthenticated) {
			next('/login'); // 如果没有认证信息，跳转到登录页面
		} else {
			axios.post("/kt-supplier/tokenlogin", {}, {
				headers: {
					token: localStorage.getItem("authToken")
				}
			}).then(res => {

				if (res.data.state == 200) {
					next();
				} else {
					next('/login');
				}
			});
		}
	} else {
		next();
	}
});

export default router